import React from 'react';
import PropTypes from 'prop-types';
import NewFiltersCheckboxList from './NewFiltersCheckboxList';

function NewFiltersItemList({filter, selectedFilters, ...others}) {
    return (<div className="filter-list">
        <p className="filter-list__header">{filter.title}</p>
        <NewFiltersCheckboxList filters={filter.values}
            keyToCheck={filter.key}
            selectedFilters={selectedFilters}
            {...others}/>
    </div>)
};

NewFiltersItemList.propTypes = {
    filter: PropTypes.object,
    selectedFilters: PropTypes.any
}

export default NewFiltersItemList;